import {
    FAIL_REQUEST,
    MAKE_REQUEST,
    CONTACT_US_LIST,
    EMAIL_LOGS_LIST,
    SET_CANCEL_ACTION_RESPONSE,
    SET_CLOSE_ACTION_RESPONSE,
    SET_REJECT_ACTION_RESPONSE,
    SET_FORWARD_ACTION_RESPONSE,
    SET_VIEW_LEAD_RESPONSE
} from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as constantMessages from "../../../../constants/constatntMessages";

export const makeRequest = () => {
    return {
        type: MAKE_REQUEST,
    };
};
export const failRequest = (err) => {
    return {
        type: FAIL_REQUEST,
        payload: err,
    };
};

export const setContactUsList = (data) => {
    return {
        type: CONTACT_US_LIST,
        payload: data,
    };
};
export const setEmailLogsList = (data) => {
  return {
      type: EMAIL_LOGS_LIST,
      payload: data,
  };
};

export const setCancelActionResponse = (data) => {
  return {
    type: SET_CANCEL_ACTION_RESPONSE,
    payload: data,
  };
};

export const setCloseActionResponse = (data) => {
  return {
    type: SET_CLOSE_ACTION_RESPONSE,
    payload: data,
  };
};

export const setRejectActionResponse = (data) => {
  return {
    type: SET_REJECT_ACTION_RESPONSE,
    payload: data,
  };
};
export const setForwardActionResponse = (data) => {
  return {
    type: SET_FORWARD_ACTION_RESPONSE,
    payload: data,
  };
};
export const viewSingleLeadResponse = (data) => {
  return {
    type: SET_VIEW_LEAD_RESPONSE,
    payload: data,
  };
};


// contact-us list
export const contactUsList = (payload) => {
    console.log(payload);
 
    return (dispatch) => {
        dispatch(makeRequest());
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/contactList`;
        const headerObject = {
            headers: {
                "Content-Type": "application/json",
                Authorization: payload.accessToken,
            },
            params: {
                limit: payload.limit,
                order: payload.order,
                page: payload.page,
                
            }
        };

        const bodyPayload = {
            searchKey: payload.searchKey ? payload.searchKey : undefined,
            toDate: payload.toDate ? payload.toDate : undefined,
            fromDate: payload.fromDate ? payload.fromDate : undefined,
        };
        console.log(headerObject);
        
        axios.post(webApiUrl, bodyPayload, headerObject)
            .then((result) => {
                const resData = result.data;
                console.log(resData);
                if (
                    (!resData.success && resData.data?.totalCount !== 0) ||
                    resData.data?.isInValidUser
                ) {
                    toast.error(resData.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                }

                dispatch(setContactUsList(resData));
            })
            .catch((err) => {
                dispatch(failRequest(err.message));
                toast.error(constantMessages.serverErrorMessage + ' User Action 1', {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }
}

// cancel lead action
export const cancelActionInLeadList = (
    leadId,
    payload, 
    searchParams,
    accessToken
) => {
    console.log(payload);
    
  return (dispatch) => {
    dispatch(makeRequest());
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/cancelLead/${leadId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;
        if (resData.success) {
          dispatch(setCancelActionResponse(resData));
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(contactUsList(searchParams));
        } else {
          dispatch(setCancelActionResponse(resData));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        dispatch(failRequest(err.message));
        toast.error(constantMessages.serverErrorMessage + ' User Action 2', {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
}

// close lead action
export const closeActionInLeadList = (
  leadId,
  payload,
  searchParams,
  accessToken
) => {
  console.log(payload);
  
return (dispatch) => {
  dispatch(makeRequest());
  const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/closeLead/${leadId}`;

  const headerObject = {
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  };

  axios
    .put(webApiUrl, payload, headerObject)
    .then((res) => {
      const resData = res.data;
      if (resData.success) {
        dispatch(setCloseActionResponse(resData));
        toast.success(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(contactUsList(searchParams));
      } else {
        dispatch(setCloseActionResponse(resData));
        toast.error(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
    .catch((err) => {
      dispatch(failRequest(err.message));
      toast.error(constantMessages.serverErrorMessage + ' User Action 3', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });
};
}

// reject lead action
export const rejectActionInLeadList = (
  leadId,
  payload,
  searchParams,
  accessToken
) => {
  console.log(payload);
  
return (dispatch) => {
  dispatch(makeRequest());
  const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/rejectLead/${leadId}`;
  const headerObject = {
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  };

  axios
    .put(webApiUrl, payload, headerObject)
    .then((res) => {
      const resData = res.data;
      if (resData.success) {
        dispatch(setRejectActionResponse(resData));
        toast.success(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(contactUsList(searchParams));
      } else {
        dispatch(setRejectActionResponse(resData));
        toast.error(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
    .catch((err) => {
      dispatch(failRequest(err.message));
      toast.error(constantMessages.serverErrorMessage + ' User Action 4', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });
};
}

// forward lead
export const forwardActionInLeadList = (
  leadId,
  payload,
  searchParams,
  accessToken
) => {
  console.log(payload);
  console.log(leadId)
return (dispatch) => {
  dispatch(makeRequest());
  const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/forwardLead/${leadId}`;
  const headerObject = {
    headers: {
      "Content-Type": "application/json",
      Authorization: accessToken,
    },
  };

  axios
    .post(webApiUrl, payload, headerObject)
    .then((res) => {
      const resData = res.data;
      if (resData.success) {
        dispatch(setForwardActionResponse(resData));
        toast.success(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        dispatch(contactUsList(searchParams));
      } else {
        dispatch(setForwardActionResponse(resData));
        toast.error(resData.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
    .catch((err) => {
      dispatch(failRequest(err.message));
      toast.error(constantMessages.serverErrorMessage + ' User Action 5', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });
};
}

// view single lead
// export const getSingleLead = (leadId, accessToken) => {
//   return (dispatch) => {
//     dispatch(makeRequest());
//     const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/lead/lead/${leadId}`;

//     const headerObject = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: accessToken,
//       },
//     };
//     axios
//       .get(webApiUrl, headerObject)
//       .then((result) => {
//         const resData = result.data;
//         if (resData.success) {
//           dispatch(viewSingleLeadResponse(resData));
//         } else {
//           dispatch(viewSingleLeadResponse(resData));
//           toast.error(resData.message, {
//             position: "top-right",
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//             progress: undefined,
//             theme: "colored",
//           });
//         }
//       })
//       .catch((err) => {
//         dispatch(failRequest(err.message));
//         toast.error(constantMessages.serverErrorMessage, {
//           position: "top-right",
//           autoClose: 4000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       });
//   };
// };

export const EmailLogsList = (payload, accessToken) => {
  console.log(payload);

  return (dispatch) => {
      dispatch(makeRequest());
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/emailLog/admin-emailLogsList`;
      const headerObject = {
          headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
          },
          params: {
              limit: payload.limit,
              order: payload.order,
              page: payload.page,
              
          }
      };

      const bodyPayload = {
          searchKey: payload.searchKey ? payload.searchKey : undefined,
          toDate: payload.toDate ? payload.toDate : undefined,
          fromDate: payload.fromDate ? payload.fromDate : undefined,
      };
      console.log(headerObject);
      
      axios.post(webApiUrl, bodyPayload, headerObject)
          .then((result) => {
              const resData = result.data;
              console.log(resData);
              if (
                  (!resData.success && resData.data?.totalCount !== 0) ||
                  resData.data?.isInValidUser
              ) {
                  toast.error(resData.message, {
                      position: "top-right",
                      autoClose: 4000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                  });
              }

              dispatch(setEmailLogsList(resData));
          })
          .catch((err) => {
              dispatch(failRequest(err.message));
              toast.error(constantMessages.serverErrorMessage + ' User Action 6', {
                  position: "top-right",
                  autoClose: 4000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
              });
          });
  }
}